import { make } from 'vuex-pathify'
import Report from '@/api/report'

const state = {
  totalPoints: 0
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async totalPoints({ commit }, payload) {
    try {
      const res = await Report.totalPoints(payload)
      commit('SET_TOTAL_POINTS', res.data.total_points)
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
